// @HTML5 FOR FIX HTML-1841 only, real implementation is omitted
export class BulkProgressEvent {
    public static PROGRESS: string = "progress";
    public static COMPLETE: string = "complete";
}
